import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography, Button  } from "@mui/material";
import { expiryLinkIcon, expiryLinkTimeOutIcon  } from "../../constants/ImageConstants";
import { useTranslation } from "react-i18next";
import { configurationServices } from "../../constants/configurationServices";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DOMPurify from 'dompurify';

const ExpiredLink = () => {
	const navigate = useNavigate();
	const { t: getLabel } = useTranslation();
	const [ config, setConfig ] = useState();
	const autoLoginMail = DOMPurify.sanitize(sessionStorage.getItem("autoLoginMail") || "");
	const { expiredLinkValidationRes } = useSelector((state) => state.signUp);

	let expireEmailTobeShown = expiredLinkValidationRes?.data?.emailAddress;
	if (autoLoginMail) {/* istanbul ignore next */
		expireEmailTobeShown = autoLoginMail;
	}

	const fetchJson = () => {
		fetch(configurationServices().LogInURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setConfig(data);
			})
			.catch((e) => {/* istanbul ignore next */
				console.log(e.message);
			});
	};

	useEffect(() => {
		fetchJson();
	}, [] );

	const source = expireEmailTobeShown ? expiryLinkIcon : expiryLinkTimeOutIcon;

	return (
		<Box mt="69px">
			<Box sx={{ mt: 3 }}>
				<div className="container-home">
					<Box textAlign="center">
						<img className="image-login" src={source} alt="expiryLink" width="78" height="77" />
						<Typography className="expiry_header" sx={{ mt: "20px" }} data-testid="expiry_header">
							{getLabel(config?.LINK_EXPIRE)}
						</Typography>
						{
							expireEmailTobeShown ?
								<>
									<Typography className="expiry_text" sx={{ mt: "24px" }} data-testid="expiry_text">
										{getLabel(config?.EXPIRE_NOTIFY)}
									</Typography>
									<Button data-testid='login-button' sx={{ mt: "24px" }}  variant="contained" onClick={() => {navigate("/forgotpasswordConfirm")}}>
										{getLabel(config?.RESET_PASSWORD_BTN)}
									</Button>
								</>
								: 
									<Typography className="expiry_text" sx={ { mt: "24px" } } data-testid="expiry_text">
											{getLabel(config?.EXPIRE_NOTIFY_EXPIRED)}
									</Typography>
						}
					</Box>
				</div>
			</Box>
		</Box>
	)
}

export default ExpiredLink;